import isCurrentlyOnBrandTVDomain from "./is-currently-on-btv-domain";
import isCurrentlyOnWebinarPlusDomain from "./is-currently-on-webinarplus-domain";

export const getThemeForCurrentLocation = () => {
	if (isCurrentlyOnBrandTVDomain()) {
		return 'brandtv';
	}
	if (isCurrentlyOnWebinarPlusDomain()) {
		return 'webinarplus';
	}
};
